import { TagsField } from '@app/components/form/tags/TagsField';
import { Stack } from '@mui/material';
import { CheckboxElement, TextFieldElement, useFormContext } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { TagGroupsFormValues } from '../types';

interface TagGroupContentProps {
  index: number;
}

export function TagGroupContent({ index }: TagGroupContentProps) {
  const { $t } = useIntl();
  const { watch, setValue } = useFormContext<TagGroupsFormValues>();
  const tagGroups = watch('tagGroups');
  const groupName = watch(`tagGroups.${index}.name`);
  const isDefault = watch(`tagGroups.${index}.default`);

  const handleDefaultChange = (isDefault: boolean) => {
    if (isDefault) {
      // If this group is being marked as default, unmark all others
      tagGroups.forEach((_, i) => {
        if (i !== index) {
          setValue(`tagGroups.${i}.default`, false);
        }
      });
    }
  };

  return (
    <Stack spacing={3}>
      <TextFieldElement
        label={$t({
          id: 'tagGroups.groupName',
          defaultMessage: 'Nombre del grupo',
        })}
        fullWidth
        name={`tagGroups.${index}.name`}
        required
      />
      <TagsField
        name={`tagGroups.${index}.tags`}
        label={$t({
          id: 'tagGroups.tags',
          defaultMessage: 'Tags',
        })}
        placeholder={$t({
          id: 'tagGroups.tagsPlaceholder',
          defaultMessage: 'Escribe y presiona Enter/coma para agregar tags',
        })}
        required
        fullWidth
      />
      <CheckboxElement
        name={`tagGroups.${index}.default`}
        label={$t({
          id: 'tagGroups.defaultGroup',
          defaultMessage: 'Grupo por defecto',
        })}
        onChange={(e) => handleDefaultChange(e.target.checked)}
      />
    </Stack>
  );
}
